import axios from "axios";

export function approveRequestTransfer(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/request-transfer/${uuid}/approve`, {})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
